/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_CoverletterInputs */

const en_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const de_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben`)
};

const fr_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const es_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const it_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const nl_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const pl_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const fi_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const da_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

const sv_landing_tab_coverletter = /** @type {(inputs: Landing_Tab_CoverletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover Letters`)
};

/**
* | output |
* | --- |
* | "Cover Letters" |
*
* @param {Landing_Tab_CoverletterInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_coverletter = /** @type {((inputs?: Landing_Tab_CoverletterInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_CoverletterInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_coverletter(inputs)
	if (locale === "fr") return fr_landing_tab_coverletter(inputs)
	if (locale === "es") return es_landing_tab_coverletter(inputs)
	if (locale === "it") return it_landing_tab_coverletter(inputs)
	if (locale === "nl") return nl_landing_tab_coverletter(inputs)
	if (locale === "pl") return pl_landing_tab_coverletter(inputs)
	if (locale === "fi") return fi_landing_tab_coverletter(inputs)
	if (locale === "da") return da_landing_tab_coverletter(inputs)
	if (locale === "sv") return sv_landing_tab_coverletter(inputs)
	return en_landing_tab_coverletter(inputs)
});